import { defaultApiState, defaultInitialState, getErrorState, loadingState } from '../utils';
import { EXPAND_SHORTLINK, EXPAND_SHORTLINK_DONE, EXPAND_SHORTLINK_ERROR, RESET_SHORTLINK } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: '' });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case EXPAND_SHORTLINK:
            return Object.assign(Object.assign({}, state), loadingState);
        case EXPAND_SHORTLINK_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), defaultApiState), { data: action.data });
        case EXPAND_SHORTLINK_ERROR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case RESET_SHORTLINK:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map